import { comMapping } from '@/components/util/Function/comMapping';

export default {
    configHeadData: [
        { title: '所属区域', prop: 'region', width: '150', issort: true },
        { title: '纳税人名称', prop: 'companyName', width: '320', issort: true },
        { title: '公司代码', prop: 'companyCode', width: '150', issort: true },
        { title: '负责人', prop: 'personInCharge', width: '150', issort: true },
        { title: '申报方式', prop: 'declarationType', width: '200', custom: true, issort: true },
        { title: '检查结果', prop: 'result', width: '150', custom: true, issort: true },
        { title: '最近检查时间', prop: 'lastCheckTime', width: '200', issort: true },
        { title: '操作', prop: 'operation', width: '150', custom: true }
    ],
    tablePagination: { pageNum: 1, pageSize: 50, total: 0, paginationkey: 0 },
    searchlist: [
        {
            prop: 'region',
            label: '所属区域',
            type: 'select',
            selectval: comMapping.$provinceOptions
        },
        {
            prop: 'result',
            label: '检查结果',
            type: 'select',
            selectval: [
                { label: '不一致', value: '2' },
                { label: '一致', value: '1' },
                { label: '未检查', value: '0' }
            ]
        },
        {
            prop: 'declarationType',
            label: '申报方式',
            type: 'select',
            selectval: [
                { label: '非零申报', value: '0' },
                { label: '零申报 - 系统申报', value: '1' },
                { label: '零申报 - 线下申报', value: '2' }
            ]
        },
        { prop: 'companyName', label: '纳税人名称', type: 'input' },
        { prop: 'companyCode', label: '公司代码', type: 'input' }
    ],
    searchdata: {
        region: '',
        result: '',
        declarationType: '',
        companyName: '',
        companyCode: '',
        period: '',
        sort: 'result',
        order: 'desc'
    }
};
